define('controllers/fieldNumber',[], function() {
    /**
     * The increment message carries a %s placeholder for the step. A message a
     * site owner saved before the placeholder existed has none, so the step is
     * appended in that case, exactly as it used to be.
     */
    function nfGetIncrementMessage( message, step ) {
        message = message || '';
        return -1 !== message.indexOf( '%s' )
            ? message.replace( '%s', step )
            : message + step;
    }

    var controller = Marionette.Object.extend( {
        initialize: function() {
            this.listenTo( nfRadio.channel( 'number' ), 'init:model', this.maybeMinDefault );
            this.listenTo( nfRadio.channel( 'number' ), 'keyup:field', this.validateEntry );
        },

        maybeMinDefault: function( model ) {

            if( '' == model.get( 'value' ) && '' == model.get( 'placeholder' ) ){
                var min = model.get( 'num_min' );
                model.set( 'placeholder', min );
            }
        },

        validateEntry: function( el, model ) {
            var $el = jQuery( el );
            var val = $el.val();
            var floatVal = parseFloat( val );
            var min = $el.attr( 'min' );
            var max = $el.attr( 'max' );
            var step = $el.attr( 'step' ) ? $el.attr( 'step' ) : '1';

            if( min && floatVal < min ){
                var fieldModel = nfRadio.channel( 'fields' ).request( 'get:field', model.get( 'id' ) );
                var formModel  = nfRadio.channel( 'app'    ).request( 'get:form',  fieldModel.get( 'formID' ) );
                nfRadio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'number-min', formModel.get( 'settings' ).fieldNumberNumMinError );
            } else {
                nfRadio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'number-min' );
            }

            if ( max && floatVal > max ){
                var fieldModel = nfRadio.channel( 'fields' ).request( 'get:field', model.get( 'id' ) );
                var formModel  = nfRadio.channel( 'app'    ).request( 'get:form',  fieldModel.get( 'formID' ) );
                nfRadio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'number-max', formModel.get( 'settings' ).fieldNumberNumMaxError );
            } else {
                nfRadio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'number-max' );
            }

            let testVal = val.split('.');
            testVal = typeof(testVal[1]) !== 'undefined' ? testVal[1].length : 0;
            let testStep = step.split('.');
            testStep = typeof(testStep[1]) !== 'undefined' ? testStep[1].length : 0;
            let factor = Math.pow(10, testStep);

            if( step && val && ( testVal > testStep
                || 0 !== parseInt((factor * floatVal).toFixed()) % parseInt((factor * parseFloat(step)).toFixed()) ) ){
                var fieldModel = nfRadio.channel( 'fields' ).request( 'get:field', model.get( 'id' ) );
                var formModel  = nfRadio.channel( 'app' ).request( 'get:form',  fieldModel.get( 'formID' ) );
                nfRadio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'number-step', nfGetIncrementMessage( formModel.get( 'settings' ).fieldNumberIncrementBy, step ) );
            } else {
                nfRadio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'number-step' );
            }
        }

    });

    return controller;
} );
